export * from './ProductDetailsIngredientHighlights';
